import { render, staticRenderFns } from "./ClubDashboard.vue?vue&type=template&id=40c1dbfa&scoped=true"
import script from "./ClubDashboard.vue?vue&type=script&lang=js"
export * from "./ClubDashboard.vue?vue&type=script&lang=js"
import style0 from "./ClubDashboard.vue?vue&type=style&index=0&id=40c1dbfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c1dbfa",
  null
  
)

export default component.exports